import { AsyncComponent } from '@frontend/components/mobile';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const Deceased = lazy(() => import('./deceased.component'));
const DeceasedDetail = lazy(() => import('./deceased-detail/deceased-detail.component'));

export function DeceasedRoutes() {
    return (
        <Route path='deceased'>
            <Route
                index
                element={
                    <AsyncComponent>
                        <Deceased />
                    </AsyncComponent>
                }
            />
            <Route path=':deceasedId'>
                <Route
                    path='detail'
                    element={
                        <AsyncComponent>
                            <DeceasedDetail />
                        </AsyncComponent>
                    }
                />
            </Route>
        </Route>
    );
}
